// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__NJvbB","rights":"Footer_rights__SKk8u"};